"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _lib = require("../../lib");

var _Row = _interopRequireDefault(require("../Row"));

var _Header = _interopRequireDefault(require("../Header"));

var _Helper = _interopRequireDefault(require("../Helper"));

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Label =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Label, _PureComponent);

  function Label(_props) {
    var _this;

    _classCallCheck(this, Label);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Label).call(this, _props));

    _defineProperty(_assertThisInitialized(_this), "onFocus", function () {
      return _this.setFocus(true);
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
      return _this.setFocus(false);
    });

    _defineProperty(_assertThisInitialized(_this), "setFocus", function () {
      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return _this.setState({
        focus: focus
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getErrorStatus", function (name) {
      var _this$state = _this.state,
          error = _this$state.error,
          validateResults = _this$state.validateResults;
      var status = validateResults[name];

      if ((0, _lib.isObj)(status)) {
        return !status.isValid;
      }

      return error;
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var propNames = ['inline', 'vertical', 'inverted'];
      var names = [Label.className];
      (0, _lib.addClassByPropName)(names, _this.props, propNames);
      (0, _lib.addClassByPropName)(names, _this.state, ['focus', 'error']);

      _common.customClassNames.addTextAlign(names, _this.props.textAlign);

      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "hasError", function () {
      var validateResults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.validateResults;
      var keys = validateResults ? Object.keys(validateResults) : [];

      if ((0, _lib.numberHasLength)(keys.length)) {
        return keys.some(function (key) {
          return !validateResults[key].isValid;
        });
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnValidate", function (result) {
      var key = result.key;

      if (key) {
        _this.setState(function (prevState) {
          var validateResults = _objectSpread({}, prevState.validateResults, _defineProperty({}, key, result));

          var error = _this.hasError(validateResults);

          return {
            validateResults: validateResults,
            error: error
          };
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderHeader", function () {
      var _this$props = _this.props,
          headerNode = _this$props.headerNode,
          content = _this$props.content,
          description = _this$props.description,
          inverted = _this$props.inverted,
          rightNode = _this$props.rightNode;
      var className = 'header';
      return (0, _lib.getRenderProps)(headerNode, {
        content: content,
        className: className,
        description: description,
        inverted: inverted,
        rightNode: rightNode
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderChild", function () {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          name = _this$props2.name,
          content = _this$props2.content;
      return _react.Children.map(children, function (child) {
        if (!child) return null;

        if (!child.props) {
          // ignore child without props
          return child;
        }

        var _child$props = child.props,
            noHelper = _child$props.noHelper,
            rest = _objectWithoutProperties(_child$props, ["noHelper"]);

        var onFocus = (0, _lib.callHandler)(_this.onFocus, child.props.onFocus);
        var onBlur = (0, _lib.callHandler)(_this.onBlur, child.props.onBlur);
        var handleValidate = (0, _lib.callHandler)(_this.handleOnValidate, child.props.onValidate);
        var error = child.props.error || (child.props.name ? _this.getErrorStatus(child.props.name) : _this.state.error);

        if (noHelper || _this.props.noHelper) {
          var childProps = _objectSpread({}, rest, {
            name: child.props.name || name,
            label: child.props.label || content,
            error: error,
            onFocus: onFocus,
            onBlur: onBlur
          });

          if (child.props.validations) {
            childProps.onValidate = handleValidate;
          }

          return _react.default.cloneElement(child, childProps);
        }

        return _react.default.createElement(_Helper.default, {
          fluid: child.props.fluid,
          name: child.props.name || name,
          label: child.props.label || content,
          error: error,
          onFocus: onFocus,
          onBlur: onBlur,
          onValidate: handleValidate
        }, function (_ref) {
          var message = _ref.message,
              onValidate = _ref.onValidate,
              props = _objectWithoutProperties(_ref, ["message", "onValidate"]);

          var childProps = _objectSpread({}, rest, {}, props);

          if (child.props.validations) {
            childProps.onValidate = onValidate;
          }

          return _react.default.cloneElement(child, childProps);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderChildren", function () {
      var children = _this.props.children;

      if (children) {
        return _react.default.createElement("div", {
          className: "children"
        }, _this.renderChild());
      }

      return null;
    });

    var _error = _props.error;
    _this.state = {
      prevProps: {
        error: _error
      },
      // this only store props.error
      error: _error,
      focus: false,
      validateResults: {}
    };
    return _this;
  }

  _createClass(Label, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          as = _this$props3.as,
          className = _this$props3.className,
          children = _this$props3.children,
          name = _this$props3.name,
          inverted = _this$props3.inverted,
          headerNode = _this$props3.headerNode,
          error = _this$props3.error,
          textAlign = _this$props3.textAlign,
          rightNode = _this$props3.rightNode,
          wrapperRef = _this$props3.wrapperRef,
          inline = _this$props3.inline,
          vertical = _this$props3.vertical,
          content = _this$props3.content,
          description = _this$props3.description,
          noHelper = _this$props3.noHelper,
          rest = _objectWithoutProperties(_this$props3, ["as", "className", "children", "name", "inverted", "headerNode", "error", "textAlign", "rightNode", "wrapperRef", "inline", "vertical", "content", "description", "noHelper"]);

      var Wrapper = (0, _lib.getElementType)(this, this.props);
      var classNames = this.classNames();
      return _react.default.createElement(Wrapper, _extends({}, rest, {
        ref: wrapperRef,
        className: classNames
      }), this.renderHeader(), this.renderChildren());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var error = props.error;
      return {
        // Store the previous props in state
        prevProps: {
          error: error
        },
        error: prevProps.error !== error ? error : state.error
      };
    } // focus

  }]);

  return Label;
}(_react.PureComponent);

exports.default = Label;

_defineProperty(Label, "className", 'MHub-Label');

_defineProperty(Label, "displayName", 'Label');

_defineProperty(Label, "propTypes", {
  as: _common.customPropTypes.as,
  name: _propTypes.default.string,
  headerNode: _common.customPropTypes.render,
  content: _propTypes.default.string,
  description: _propTypes.default.node,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  inline: _propTypes.default.bool,
  vertical: _propTypes.default.bool,
  rightNode: _propTypes.default.node,
  error: _propTypes.default.bool,
  textAlign: _common.customPropTypes.textAlign,
  inverted: _propTypes.default.bool,
  noHelper: _propTypes.default.bool,
  wrapperRef: _common.customPropTypes.ref
});

_defineProperty(Label, "defaultProps", {
  as: 'label',
  name: null,
  headerNode: function headerNode(_ref2) {
    var className = _ref2.className,
        rightNode = _ref2.rightNode,
        content = _ref2.content,
        rest = _objectWithoutProperties(_ref2, ["className", "rightNode", "content"]);

    if (content) {
      return _react.default.createElement(_Row.default, {
        className: className,
        middle: true,
        between: true
      }, _react.default.createElement(_Header.default, _extends({}, rest, {
        capitalize: true
      }), content), rightNode);
    }

    return null;
  },
  content: null,
  description: null,
  children: null,
  className: null,
  inline: false,
  vertical: false,
  rightNode: null,
  error: false,
  textAlign: 'left',
  inverted: false,
  noHelper: false,
  wrapperRef: null
});